// Words the number of days until or since a shipment's need-by date.
// A negative count previously appeared as "-7 days away".
export function needByLabel(days) {
  if (typeof days !== 'number' || !Number.isFinite(days)) return '';
  if (days < 0) return `${-days} day${days === -1 ? '' : 's'} ago`;
  if (days === 0) return 'today';
  return `${days} day${days === 1 ? '' : 's'} away`;
}
